import React, { useState } from 'react'
import { FaChevronRight } from 'react-icons/fa6'
import { useNavigate } from "react-router-dom"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './ContactForm.css'

function ContactForm({ thankYouSource = "default" }) {

  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [result, setResult] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [countryCode, setCountryCode] = useState('974')

  const isPhoneValid = (value) => {
    const digitsOnly = value.replace(/\D/g, '')
    return digitsOnly.length >= 8
  }
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault()

    if (!isPhoneValid(phoneNumber)) {
      setPhoneError('Please enter a valid phone number.')
      return
    }

    setPhoneError('')
    setIsSubmitting(true)
    setResult('Sending....')

    const formData = new FormData(event.target)
    formData.append('access_key', '203978f5-c86a-411c-a5cb-6f391ab8d4ac')
    formData.set('phone', `+${phoneNumber}`)

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    if (data.success) {
      // 🔹 Call backend for emails (internal + confirmation)
      await fetch("/api/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: formData.get("name"),
          email: formData.get("email"),
          country_code: countryCode,
          phone: `+${phoneNumber}`,
          services: formData.get("services"),
          budget_range: formData.get("budget_range"),
          message: formData.get("message")
        })
      });

      setPhoneNumber('')
      setPhoneError('')
      setResult('Form Submitted Successfully')
      setIsSubmitting(false)
      navigate(`/thank-you?source=${encodeURIComponent(thankYouSource)}`)
      // event.target.reset()
      setTimeout(() => setResult(''), 10000)
    } else {
      setResult('Error')
      setTimeout(() => setResult(''), 10000)
    }
  }

  return (
    <div className='hmslder-img'>
      <form onSubmit={onSubmit}>
        <h4>Tell us about your project</h4>
        <div className='form-group'>
          <div className='form-control'>
            <label>Name</label>
            <input type='text' placeholder='Name' name="name" required />
          </div>
          <div className='con-phn'>
            <label>Phone</label>
            <PhoneInput
              country={'qa'}
              value={phoneNumber}
              onChange={(value,country) => {
                setPhoneNumber(value)
                setCountryCode(country.dialCode)
                if (phoneError && isPhoneValid(value)) {
                  setPhoneError('')
                }
              }}
              placeholder="Enter phone number"
              inputProps={{
                name: 'phone',
                required: true
              }}
              enableSearch
            />
          </div>
          {phoneError && <p className='form-error'>{phoneError}</p>}
        </div>
        <div className='form-group'>
          <div className='form-control'>
            <label>Email</label>
            <input type='email' placeholder='Email' name="email" required />
          </div>
          <div className='form-control'>
            <label>Budget Range  </label>
            <select name="budget_range" defaultValue="">
              <option value="">Select Budget Range </option>
              <option value="USD 500 – USD 5,000">USD 500 – USD 5,000</option>
              <option value="USD 5,000 – USD 20,000">USD 5,000 – USD 20,000</option>
              <option value="USD 20,000 – USD 50,000">USD 20,000 – USD 50,000</option>
              <option value="USD 50,000+">USD 50,000+</option>
            </select>
          </div>
        </div>
        <div className='form-group services-select'>
            <label>Services  </label>
            <select name="services" defaultValue="">
              <option value="">Select Services</option>
              <option value="Website Design & Development">Website Design & Development</option>
              <option value="Mobile Application Development">Mobile Application Development</option>
              <option value="Custom Software Development">Custom Software Development</option>
              <option value="E-Commerce Development">E-Commerce Development</option>
              <option value="SaaS Development">SaaS Development</option>
            </select>
          
        </div>
        <div className='form-group'>
          <label>About Project</label>
          <textarea placeholder='Describe your project' name="message" required></textarea>
        </div>
        <button disabled={isSubmitting} className='btn-main'><span>Submit</span> <FaChevronRight /> </button>
        {result && <p className='form-status'>{result}</p>}
      </form>
    </div>
  )
}

export default ContactForm